import { AuthService } from '../../servicios/auth.service';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck, Output } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog, MatSidenavModule, MatTooltipModule} from '@angular/material';
//tablematerial1
import {MatTableModule} from '@angular/material/table';

import { SelectionModel, DataSource } from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { environment } from "environments/environment";

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { stringify } from '@angular/compiler/src/util';

//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { EventEmitter } from 'events';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';
//material1
export interface DatosGrid {
  IDSEC: string;
  SECDEL: string;
  USER: string;
  NOMBRE: string;
  IMPORTE: string;
  CATEGO: string;
  DETALLECUENTA: string;
  DESDE: string;
  HASTA: string;
  MOTIVO: string;
}

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent implements OnInit {
  //material3
  displayedColumns: string[] = ['IDSEC', 'SECDEL', 'USER', 'NOMBRE', 'IMPORTE','CATEGO','DETALLECUENTA','DESDE','HASTA','MOTIVO'];
  dataSourceGrid = new MatTableDataSource<DatosGrid>();
  //dataSource = new MatTableDataSource(ELEMENT_DATA);
  @ViewChild(MatPaginator, {}) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;


  @ViewChild('REPORTE') reporte: ElementRef;
  loading;
  dataSourceReporte = new MatTableDataSource();
  dataSourceSeccionales;
  dateValue: any;
  dateValue2: any;
  selectedDate;
  selectedDate2;
  fecha_ticket;
  fecha_ticket2;
  control=false;
  filtroSec;
  filtroUs;
  dataSourceUsers;
  contGrid;
  
    constructor(
      private http: HttpClient,
      public dialog: MatDialog,
      private datePipe: DatePipe,
      //snackbar 2
      public snackBar: MatSnackBar
    ) { 
      this.loading=false;
    }
  
    ngDoCheck(){
      //para habilitar boton
      if ((!this.fecha_ticket) || (!this.fecha_ticket2)){
        this.control=false;
        console.log("fechas inc..");
      }else{
        this.control=true;
        console.log("fechas ok!");
      }
      console.log("CONTROL:" + this.control);
    
      //para cerrar modal si termina el loading
      if (this.loading==true){
      }else{
        document.getElementById("salemodal").click(); 
      }
      this.contGrid = this.dataSourceGrid.data.length
      //datos de filtro
      console.log("fechades: " + this.fecha_ticket);
      console.log("fechahas:" + this.fecha_ticket2);
      console.log("sec:" + this.filtroSec);
      console.log("us:" + this.filtroUs);
      console.log("cue:" + this.filtroCue);
      console.log("mot:" + this.filtroMot);
      console.warn(this.contGrid);
    
    }
    onActivate(event) {
      window.scroll(0,0);
      //or document.body.scrollTop = 0;
      //or document.querySelector('body').scrollTo(0,0)
    }
  
    ngOnInit() {
     // this.fecha_ticket='0000-00-00';
     // this.fecha_ticket2='2099-01-01';
     this.filtroSec="TODAS_LAS_SECCIONALES";
     this.filtroUs = "TODOS_LOS_USUARIOS";
     this.filtroCue = "TODAS_LAS_CUENTAS";
     this.filtroMot = "TODOS_LOS_MOTIVOS"
    }
  
    //mandioca2019 (exporta datasource)
    exportExcel(data: any[]){
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      XLSX.writeFile(workbook, `ReporteCompleto_${this.fecha_ticket}_${this.fecha_ticket2}.xls`, { bookType: 'xls', type: 'buffer' });
   }
  
    exportAsExcelReporte(ds) {
      console.log("Generando reporte..");
      this.exportExcel(ds);
    }
  
    addEvent( input: string, $event ) {
      this.selectedDate = moment($event.value).format('YYYY-MM-DD');
      this.fecha_ticket=this.selectedDate;
      moment(this.fecha_ticket).format('YYYY-MM-DD')
      console.log("fecha desde:" + this.fecha_ticket);
    }
  
    addEvent2( input: string, $event ) {
      this.selectedDate2 = moment($event.value).format('YYYY-MM-DD');
      this.fecha_ticket2=this.selectedDate2;
      moment(this.fecha_ticket2).format('YYYY-MM-DD')
      console.log("fecha hasta:" + this.fecha_ticket2);
    }

    applyFilter(filterValue: string) {
      this.dataSourceGrid.filter = filterValue.trim().toLowerCase();
  
      if (this.dataSourceGrid.paginator) {
        this.dataSourceGrid.paginator.firstPage();
      }
    }
  
    l_repo = false;
    cargarGrid(){
      this.l_repo=true;
      //http://localhost:1337/api/rep-est/completo?fdes=2019-05-01&fhas=2019-05-31&idsec=21&user=28933205&cue=TODAS_LAS_CUENTAS
      this.http.get(`${environment.backendUrl}/api/rep-est/completo?fdes=${this.fecha_ticket}&fhas=${this.fecha_ticket2}&idsec=${this.filtroSec}&user=${this.filtroUs}&cue=${this.filtroCue}`)
      .subscribe((datos: any[]) => {
        if (datos){
          console.log("parametros con datos!");
          this.dataSourceGrid.data = datos[0];
          console.warn(this.dataSourceGrid.data);
          //this.exportAsExcelReporte();
          this.l_repo=false;
          this.dataSourceGrid.paginator = this.paginator;
          this.dataSourceGrid.sort = this.sort;
        }else{
          console.log("no se encontraron datos con esos parametros..");
          this.l_repo=false;
        }
      });

    }

    getRepo(){
      this.exportAsExcelReporte(this.dataSourceGrid.data);
    }

    calculaSec(){
      this.dataSourceSeccionales=null;
      console.log("calculando seccionales");
      this.loading=true;
      //localhost:1337/api/rep-est/calsec?fdes=0000-00-00&fhas=2099-01-01
      this.http.get(`${environment.backendUrl}/api/rep-est/calsec?fdes=${this.fecha_ticket}&fhas=${this.fecha_ticket2}`)
      .subscribe((datos: any[]) => {
        if(datos){
          console.warn("HAY " + datos[0].length);
          this.dataSourceSeccionales = datos[0];
          console.warn(this.dataSourceSeccionales);
        }else{
          console.warn("NO HAY");
        };
        this.loading=false;
      });
    }

    l_us;
    calculaUser(){
      this.dataSourceUsers=null;
      console.log("calculando usuarios");
      this.l_us=true;
     //http://localhost:1337/api/rep-est/caluser?fdes=0000-00-00&fhas=2099-01-01&idsec=03
      this.http.get(`${environment.backendUrl}/api/rep-est/caluser?fdes=${this.fecha_ticket}&fhas=${this.fecha_ticket2}&idsec=${this.filtroSec}`)
      .subscribe((datos: any[]) => {
        if(datos){
          console.warn("HAY " + datos[0].length + " USERS");
          this.dataSourceUsers = datos[0];
          console.warn(this.dataSourceUsers);
          this.filtroUs = "TODOS_LOS_USUARIOS";
        }else{
          console.warn("NO HAY USERS");
        };
        this.l_us=false;
      });
    }

    l_cue;
    dataSourceCuentas;
    filtroCue;
    calculaCuentas(){
      this.dataSourceCuentas=null;
      console.log("calculando cuentas");
      this.l_cue=true;
     //http://localhost:1337/api/rep-est/calcuen?fdes=0000-00-00&fhas=2099-01-01&idsec=03&idus=TODOS_LOS_USUARIOS
      this.http.get(`${environment.backendUrl}/api/rep-est/calcuen?fdes=${this.fecha_ticket}&fhas=${this.fecha_ticket2}&idsec=${this.filtroSec}&idus=${this.filtroUs}`)
      .subscribe((datos: any[]) => {
        if(datos){
          console.warn("HAY " + datos[0].length + " CUENTAS");
          this.dataSourceCuentas = datos[0];
          console.warn(this.dataSourceCuentas);
          this.filtroCue = "TODAS_LAS_CUENTAS";
        }else{
          console.warn("NO HAY CUENTAS");
        };
        this.l_cue=false;
      });
    }
    
    l_mot;
    dataSourceMotivos;
    filtroMot;
    calculaMotivos(){
      this.dataSourceMotivos=null;
      console.log("calculando cuentas");
      this.l_mot=true;
     //http://localhost:1337/api/rep-est/calmoti?fdes=0000-00-00&fhas=2099-01-01&idsec=03&idus=TODOS_LOS_USUARIOS&idcue=TODAS_LAS_CUENTAS
      this.http.get(`${environment.backendUrl}/api/rep-est/calmoti?fdes=${this.fecha_ticket}&fhas=${this.fecha_ticket2}&idsec=${this.filtroSec}&idus=${this.filtroUs}&idcue=${this.filtroCue}`)
      .subscribe((datos: any[]) => {
        if(datos){
          console.warn("HAY " + datos[0].length + " motivos!");
          this.dataSourceMotivos = datos[0];
          console.warn(this.dataSourceMotivos);
          this.filtroMot = "TODOS_LOS_MOTIVOS";
        }else{
          console.warn("NO HAY motivos");
        };
        this.l_mot=false;
      });
   
    }
    
    blaUsCueMot(param){
      //this.dataSourceUsers = null;
      param = null;
    }


  
    
 
}